import { useMutation } from 'react-query';

import { deleteStoredFilterBulkAssignOrRemoveTags as mutationFn } from 'api/endPoints/deleteStoredFilterBulkAssignOrRemoveTags';

export const useMutationDeleteStoredFilterBulkAssignOrRemoveTags = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    id: string;
    contractId: number;
}
